import { render, staticRenderFns } from "./WSelect.vue?vue&type=template&id=1706c2f4&scoped=true&"
import script from "./WSelect.vue?vue&type=script&lang=js&"
export * from "./WSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706c2f4",
  null
  
)

export default component.exports